module.exports = __webpack_public_path__ + "static/proxy_1-489b9c165c5559935825f9de346e4585.png";